var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquigglyLineTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 209,
    viewBox: "0 0 356 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23072 0C5.23072 0 -0.858066 47.9704 14.0505 71.8156C29.6252 96.7263 56.0785 92.1399 77.7488 110.716C108.979 137.486 85.4308 144.419 115.478 172.557C137.72 193.386 149.94 204.23 180.156 204.974C202.122 205.514 213.159 197.676 231.605 185.524C258.627 167.721 259.833 148.082 285.013 127.672C324.269 95.8531 408 89.7695 408 89.7695",
    stroke: "#43D079",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquigglyLineTopRight);
export default __webpack_public_path__ + "static/media/squiggly-line-top-right.7501003db831f1072aa2dca42f427c8a.svg";
export { ForwardRef as ReactComponent };